String.prototype.toTitleCase = function() {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.isValidDateStrFormat = function(allowEmpty: boolean = true ): boolean {
    if (allowEmpty && this.trim() === '') {
        return true;
    }
    return this.match(/^\d{4}-\d{2}-\d{2}$/) !== null;
};


String.prototype.toDate = function(): Date {

    if ( !(this.isValidDateStrFormat (false))) {
        return null;
    }

    const splits = this.split('-');
    const year = +splits[0];
    const month = +splits[1];
    const days = +splits[2];

    // Can not use new Date (str), based on timezone, the days in might be offset 1 day
    const dt = new Date (year, month - 1, days  );
    if (!(dt instanceof Date)) {
      return null; // For Invalid Date
    }

    // exceeded month, days would overflow to next/previous dates
    if (dt.getFullYear() === year && dt.getMonth() === month - 1 && dt.getDate() === days) {
        return dt;
    } else {
        return null;
    }
};

String.prototype.isValidDateTimeStrFormat = function(allowEmpty: boolean = true ): boolean {
    if (allowEmpty && this.trim() === '') {
        return true;
    }
    return this.match(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]), ([01][0-9]|2[0-3]):([0-5][0-9])$/) !== null;
};

String.prototype.toDateTime = function(): Date {

    if ( !(this.isValidDateTimeStrFormat (false))) {
        return null;
    }
    const splitsDateTime = this.split(', ');
    const splitsDate = splitsDateTime[0].split('-');
    const splitsTime = splitsDateTime[1].split(':');
    const year = +splitsDate[0];
    const month = +splitsDate[1];
    const days = +splitsDate[2];
    const hours = +splitsTime[0];
    const miniutes = +splitsTime[1];

    // Can not use new Date (str), based on timezone, the days in might be offset 1 day
    const dt = new Date (year, month - 1, days, hours, miniutes );
    if (!(dt instanceof Date)) {
      return null; // For Invalid Date
    }

    // exceeded month, days would overflow to next/previous dates
    if (dt.getFullYear() === year && dt.getMonth() === month - 1 && dt.getDate() === days
        && dt.getHours() === hours && dt.getMinutes() === miniutes) {
        return dt;
    } else {
        return null;
    }
};

String.prototype.isIsoDate = function(): boolean {
    if (!this.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/)) {
        return false;
    }
    const d = new Date(this);
    return d.toISOString() === this;
};
